import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import Sagas from "./Sagas";

import { rootReducer, whitelist } from "./rootReducer";

const persistConfig = {
	key: "lims_admin",
	storage,
	whitelist: whitelist,
	stateReconciler: autoMergeLevel2,
};

const sagaMiddleware = createSagaMiddleware();
const persistedReducer = persistReducer(persistConfig, rootReducer);

const middleware =
	process.env.NODE_ENV === "production"
		? [sagaMiddleware]
		: [sagaMiddleware, logger];

const store = configureStore({
	reducer: persistedReducer,
	middleware,
	devTools: process.env.NODE_ENV !== "production",
});

sagaMiddleware.run(Sagas);

export default store;
